import axios from 'axios'
import { ErrorService } from './error.service'

const ApiService = {

  get (resource, config = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/${resource}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  async post (resource, payload, config = {}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/${resource}`, payload, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  put (resource, payload, config = {}) {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.VUE_APP_API_URL}/${resource}`, payload, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  delete (resource, config = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/${resource}`, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  }
}

export default ApiService
